/* eslint-disable no-unused-vars */
/** @jsx jsx */
import { jsx } from '@emotion/core'
import {
  Button,
  DatePicker,
  Input,
  InputNumber,
  Modal,
  Select,
  Spin,
  message,
} from 'antd'
import styled from 'styled-components'
import { ErrorContext, JcTmpErrorContext, SpinContext } from 'context'
import { hasAccesPermits } from 'core/utils'
import { Label } from 'core/screen-util'
import React, { useContext, useMemo, useState } from 'react'
import { connect } from 'react-redux'
import R from 'ramda'
import moment from 'moment'
import MultiCauseCode from 'card-data/MultiCauseCode'
import { solarEventUpdateInverter } from 'api/pgads'
import { isErrorContains } from 'core/component/JcTmpErrorDialog'
import { getTimeZone, timeZoneOption } from 'wind2/wind2utils'
import {
  SHOW_SOLAR_STORAGE_STANDALONE_DATA_ADMIN,
  SOLAR_ADMIN_POWER_DATA,
} from '../core/EventActions'
import { getPermitActions } from '../core/selectors'
import { solarStorageInvEventUpdateInverter } from './solarapi'
export const saveDateformat = 'MM/DD/YYYY HH:mm'

const CustomSelect = styled(Select)`
  .ant-select-selection--multiple {
    max-height: 120px; /* Adjust height as needed */
    overflow-y: auto; /* Enable scrolling when content overflows */
  }
`

const SolarInverterEventDialog = ({
  targetInfo,
  visible,
  data = {},
  onHide = _ => _,
  onRetrieve,

  isNew = false,
  causeCodeList,
  contribConditionList = [],
  selectedPlantDetails = {},
  inverterIdBYPlant = [],
  eventTypes = [],
  actionPermits,
  isStorageDialog = false,
  storageGroupNameMap = {},
}) => {
  const { spinning, setSpinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)
  const { timeZone = 'EST', daylightSaving = 'Y' } = selectedPlantDetails
  const efffEventType = eventTypes.filter(
    f => f.eventFor === (isStorageDialog ? 'S' : 'I')
  )

  const hasSolarPowerDataWritePermission = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits: actionPermits,
        eventActions: [
          SOLAR_ADMIN_POWER_DATA,
          SHOW_SOLAR_STORAGE_STANDALONE_DATA_ADMIN,
        ],
        matchAny: true,
      }),
    [actionPermits]
  )

  const [insertData, setInsertData] = useState({
    ...data,
    contributingCondition: data.contributingCondition || '0',
  })

  const { setTmpError } = useContext(JcTmpErrorContext)
  const onSave = _ => {
    const {
      entityId,
      plantId,
      eventstart,
      eventstartTimeZone,
      causecode,
      contributingCondition,
      inverterId,
    } = insertData
    if (!inverterId) {
      message.info('Please, Select Inverter Id.')
      return
    }
    if (!entityId) {
      message.info('Please, Select Entity.')
      return
    }
    if (!plantId) {
      message.info('Please, Select Plant.')
      return
    }
    if (!eventstart) {
      message.info('Please. Select Event Start Time.')
      return
    }
    if (!eventstartTimeZone) {
      message.info('Please ,Select Event Start Time Zone.')
      return
    }
    setSpinning(true)

    const inverterIds = Array.isArray(inverterId) ? inverterId : [inverterId]
    const records = inverterIds.map(id => ({
      ...insertData,
      inverterId: id,
    }))

    const api = isStorageDialog
      ? solarStorageInvEventUpdateInverter
      : solarEventUpdateInverter
    api(targetInfo)(records).fork(setError, errorList => {
      setSpinning(false)
      setTmpError(errorList)
      if (!isErrorContains(errorList)) {
        message.info('Data saved.')
        onHide()
        onRetrieve()
      }
    })
  }

  const [causeCodeDialog, setCauseCodedialog] = useState({
    causeCodeDialog: false,
  })

  const onCauseCodeDialogClose = (causeCodeKeyValues, causeCodeValues) => {
    setInsertData({
      ...insertData,
      causecode: causeCodeValues[0] && causeCodeValues[0].causeCode,
    })
    setCauseCodedialog({
      causeCodeDialog: false,
      causeCodeKeyValues,
      causeCodeValues,
      causecode: causeCodeValues
        ? causeCodeValues.length > 0
          ? causeCodeValues[0].causeCode
          : ''
        : insertData.causecode,
    })
  }

  const onCauseCodeTreeCancel = causeCodeKeyValues => {
    setCauseCodedialog({
      causeCodeKeyValues,
      causeCodeDialog: false,
    })
  }
  const openCauseCodeDialog = _ => {
    setCauseCodedialog({
      causecode: insertData.causecode,
      causeCodeDialog: true,
    })
  }

  const plnatGroupList = useMemo(
    _ => {
      return R.compose(
        R.uniq,
        R.map(({ storageGroupId }) => storageGroupId)
      )(inverterIdBYPlant)
    },
    [inverterIdBYPlant]
  )

  return (
    <Modal
      visible={visible}
      centered
      height={400}
      width={1100}
      title={<div> Inverter Event Dialog </div>}
      footer={
        <div>
          <div>
            {hasSolarPowerDataWritePermission && (
              <Button type="primary" onClick={onSave}>
                Save{' '}
              </Button>
            )}
            <Button onClick={onHide}>Cancel</Button>
          </div>
        </div>
      }
      onCancel={onHide}
    >
      <Spin spinning={spinning}>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '250px 200px 150px 200px 150px',
            gap: 5,
          }}
        >
          {/* <Label>Time Zone :</Label>
          <Select value={insertData.timeZone}>
            <Select.Option value="EST">EST</Select.Option>
            <Select.Option value="EDT">EDT</Select.Option>
          </Select> */}

          {!isNew &&
            isStorageDialog && [
              <Label key="lab">Storage Group ID :</Label>,
              <Input
                key="txt"
                style={{ gridColumnEnd: 'span 1' }}
                value={insertData.storageGroupId}
                onChange={e =>
                  setInsertData({
                    ...insertData,
                    storageGroupId: e.target.value,
                  })
                }
                disabled
              />,
              <div style={{ gridColumnEnd: 'span 3' }} key="gap" />,
            ]}
          {isNew &&
            isStorageDialog && [
              <Label key="lab">Storage Group ID :</Label>,
              <Select
                key="stsel"
                value={insertData.storageGroupId}
                onChange={storageGroupId =>
                  setInsertData({ ...insertData, storageGroupId })
                }
              >
                {plnatGroupList.map(storageGroupId => (
                  <Select.Option key={storageGroupId} value={storageGroupId}>
                    {storageGroupId}{' '}
                    {storageGroupNameMap[
                      insertData.plantId + '-' + storageGroupId
                    ]
                      ? '-' +
                        storageGroupNameMap[
                          insertData.plantId + '-' + storageGroupId
                        ]
                      : ''}
                  </Select.Option>
                ))}
              </Select>,
              <div style={{ gridColumnEnd: 'span 3' }} key="gap" />,
            ]}

          <Label>Inverter ID :</Label>
          {!isNew && (
            <Input
              style={{}}
              value={insertData.inverterId}
              onChange={e =>
                setInsertData({ ...insertData, inverterId: e.target.value })
              }
              disabled
            />
          )}

          {isNew && (
            <CustomSelect
              showSearch
              mode="multiple"
              css={{ gridColumnEnd: 'span 4', width: '100%' }}
              value={insertData.inverterId}
              onChange={inverterId => {
                if (inverterId.includes('ALL')) {
                  setInsertData({
                    ...insertData,
                    inverterId: inverterIdBYPlant.map(d => d.inverterId),
                  })
                } else {
                  setInsertData({ ...insertData, inverterId })
                }
              }}
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              <Select.Option key="ALL" value="ALL">
                ALL
              </Select.Option>
              {inverterIdBYPlant.map(({ inverterId }) => (
                <Select.Option key={inverterId} value={inverterId}>
                  {inverterId}
                </Select.Option>
              ))}
            </CustomSelect>
          )}
          {!isNew && <div style={{ gridColumnEnd: 'span 3' }} />}

          <Label>Event Start :</Label>
          <DatePicker
            style={{}}
            value={
              insertData.eventstart &&
              moment(insertData.eventstart, saveDateformat)
            }
            showTime={{
              format: 'h:mm',
              defaultValue: moment('00:00', 'HH:mm'),
            }}
            format="MM/DD/YYYY HH:mm"
            placeholder="Select DateTime"
            onChange={date => {
              const zone = getTimeZone({
                pzone: timeZone,
                daylightSavings: daylightSaving,
                date,
              })
              setInsertData({
                ...insertData,
                eventstart: date.format(saveDateformat),
                eventstartTimeZone: zone,
              })
            }}
            onOk={date => {
              const zone = getTimeZone({
                pzone: timeZone,
                daylightSavings: daylightSaving,
                date,
              })
              setInsertData({
                ...insertData,
                eventstart: date.format(saveDateformat),
                eventstartTimeZone: zone,
              })
            }}
          />
          <Label>Start Time Zone :</Label>
          <Select
            value={insertData.eventstartTimeZone}
            onChange={eventstartTimeZone =>
              setInsertData({ ...insertData, eventstartTimeZone })
            }
          >
            {timeZoneOption({
              pzone: timeZone,
              daylightSavings: daylightSaving,
            }).map(t => (
              <Select.Option key={t.key} value={t.value}>
                {t.text}
              </Select.Option>
            ))}
          </Select>
          <div style={{ gridColumnEnd: 'span 1' }} />
          <Label>Event End :</Label>
          <DatePicker
            style={{ width: '100%' }}
            value={
              insertData.eventend && moment(insertData.eventend, saveDateformat)
            }
            showTime={{
              format: 'h:mm',
              defaultValue: moment('00:00', 'HH:mm'),
            }}
            format="MM/DD/YYYY HH:mm"
            placeholder="Select DateTime"
            onChange={date => {
              const zone = getTimeZone({
                pzone: timeZone,
                daylightSavings: daylightSaving,
                date,
              })
              setInsertData({
                ...insertData,
                eventend: date.format(saveDateformat),
                eventendTimeZone: zone,
              })
            }}
            onOk={date => {
              const zone = getTimeZone({
                pzone: timeZone,
                daylightSavings: daylightSaving,
                date,
              })
              setInsertData({
                ...insertData,
                eventend: date.format(saveDateformat),
                eventendTimeZone: zone,
              })
            }}
          />
          <Label>End Time Zone :</Label>
          <Select
            value={insertData.eventendTimeZone}
            onChange={eventendTimeZone =>
              setInsertData({ ...insertData, eventendTimeZone })
            }
          >
            {timeZoneOption({
              pzone: timeZone,
              daylightSavings: daylightSaving,
            }).map(t => (
              <Select.Option key={t.key} value={t.value}>
                {t.text}
              </Select.Option>
            ))}
          </Select>

          <div style={{ gridColumnEnd: 'span 1' }} />
          <Label>Event Type :</Label>
          <Select
            value={insertData.eventtype}
            onChange={eventtype => setInsertData({ ...insertData, eventtype })}
          >
            {efffEventType.map(d => (
              <Select.Option key={d.id} value={d.id}>
                {d.id}
              </Select.Option>
            ))}
            {/* <Select.Option key="FO" value="FO">
              FO
            </Select.Option>
            <Select.Option key="IO" value="IO">
              IO
            </Select.Option>
            <Select.Option key="MO" value="MO">
              MO
            </Select.Option>
            <Select.Option key="PO" value="PO">
              PO
            </Select.Option> */}
          </Select>
          {/* <Input
            value={insertData.eventtype}
            onChange={e =>
              setInsertData({ ...insertData, eventtype: e.target.value })
            }
            disabled
          /> */}
          <Label>Cause Code :</Label>

          <InputNumber
            style={{ width: '100%' }}
            value={insertData.causecode}
            onChange={causecode => setInsertData({ ...insertData, causecode })}
          />
          <Button type="primary" onClick={openCauseCodeDialog}>
            Select Causecode
          </Button>

          <Label>Contributing Operating Condition :</Label>

          <Select
            value={insertData.contributingCondition}
            onChange={contributingCondition =>
              setInsertData({ ...insertData, contributingCondition })
            }
            style={{ gridColumnEnd: 'span 3' }}
          >
            {contribConditionList.map(d => (
              <Select.Option key={d.contOpCode} value={d.contOpCode}>
                {d.contOpCode} - {d.contOpCondition}
              </Select.Option>
            ))}
          </Select>
          <div style={{ gridColumnEnd: 'span 1' }} />
          <Label>Event Description :</Label>
          <Input.TextArea
            css={{ gridColumnEnd: 'span 4', width: '100%' }}
            value={insertData.description}
            onChange={e =>
              setInsertData({
                ...insertData,
                description: e.target.value,
              })
            }
          />
        </div>
      </Spin>
      {causeCodeDialog.causeCodeDialog && (
        <MultiCauseCode
          key="multicausecodelist"
          // style={{ ...inlineStyle }}
          // checkable={false}
          visibleDialog={causeCodeDialog.causeCodeDialog}
          onDialogClose={onCauseCodeDialogClose}
          onCancelAction={onCauseCodeTreeCancel}
          defaultExpandedKeys={
            insertData.causecode ? causeCodeDialog.selectedKeys : []
          }
          selectedKeys={causeCodeDialog.causeCodeKeyValues}
          selectedValues={causeCodeDialog.causeCodeValues}
          // selectedValues={this.state.causeCodeValues || []}
          unitCodes={[]}
          multiple={false}
          checkable={false}
          selectable
          causeCodeValue={[insertData.causecode]}
          causeCodeList={causeCodeList}
        />
      )}
    </Modal>
  )
}

const mapStateToProps = state => ({ actionPermits: getPermitActions(state) })

export default connect(mapStateToProps)(SolarInverterEventDialog)
